<script>
	const config = require('core/config');
	const utilities = require('utilities');
	const articleContentMixin = require('mixins/article-content');
	const analyticsUtilities = require('utilities/analyticsUtilities');
	const fireEvent = analyticsUtilities.fireEvent;
	const LISTENING_LEVEL_BUTTER_BAR_HIDDEN = analyticsUtilities.events.LISTENING_LEVEL_BUTTER_BAR_HIDDEN;

	module.exports = {
		mixins: [articleContentMixin],
		props: {
			article: {
				required: true,
				type: Object
			},
			articleList: {
				default: null
			},
			selectedArticle: {
				default: null
			},
			routeContext: {
				default: null
			},
			stepRead: {
				default: null
			},
			onArticleSelect: {
				type: Function,
				default() {}
			},
			showAudio: {
				default: true
			},
			showChallenge: {
				default: true
			},
			showSupport: {
				default: true
			},
			student: {
				default: null
			},
			annotations: {
				default: null
			},
			forceHighlighting: {
				default: false
			},
			paragraphsNumbered: {
				default: false
			},
			decodables: {
				default: false
			},
			hasWorkspace: {
				default: false
			}
		},
		components: {
			paywall: require('components/paywall.vue').default,
			'paywall-print-warning': require('components/paywall-print-warning.vue').default,
			'audio-player': require('components/audio-player.vue').default,
			'product-news-header': require('components/product-news-header.vue').default,
			'video-content': require('components/video-content.vue').default,
			'vocab-popup-content-wrapper': require('components/vocab-popup-content-wrapper.vue').default,
			'butter-bar-promo': require('components/butter-bar-promo.vue').default,
			'outbound-link': require('components/outbound-link.vue').default,
			'article-selection': require('components/article-selection.vue').default
		},
		modelData: ['userContext', 'hideKor1ListeningLevelButterBar', 'articleTab'],
		data: function () {
			return {
				articleHasFewWords: false
			};
		},
		computed: {
			userIsUnauthenticated: function () {
				// Compute based on user auth state
				// Also tre 'aat students as unauthenticated
				return !this.userContext || this.userContext.classCode;
			},
			content: function () {
				let article = this.article;
				let articleList = this.articleList;
				this.articleHasFewWords = false;
				let text = '';

				if (article) {
					if (articleList && articleList.length > 0) {
						article = this.selectedArticle;
					}

					let content = article.content;
					let preview = null;

					if (this.userIsUnauthenticated && content) {
						preview = utilities.createPreview(article);
						if (preview.wordCount <= 5) {
							this.articleHasFewWords = true;
						}
						content = preview.content;
					}

					/* Update tags on vocab words */
					content = utilities.cleanVocabLinks(content);

					var $content = $(content);

					if ($content.hasClass('lined-poem')) {
						$content.find('li').each(function (i, node) {
							if ((i + 1) % 5 === 0) {
								$('<li style="float:right">' + (i + 1) + '</li>').insertBefore(node);
							}
						});

						text = $.fn.append.apply($('<div>'), $content).html();
					} else {
						text = content;
					}
				}
				return text;
			},
			paywallAbsolutePositioning: function () {
				return this.userIsUnauthenticated && this.articleHasFewWords;
			},
			isNewsArticle: function () {
				let article = this.selectedArticle || this.article;
				if (article && article.subType === 102) {
					return true;
				}
				return false;
			},
			isVideoArticle() {
				let article = this.selectedArticle || this.article;
				if (article && article.video && article.subType === 103) {
					return true;
				}
				return false;
			},
			hasAudio: function () {
				let article = this.article;
				let selectedArticle = this.selectedArticle;

				if (!article) {
					return false;
				}

				return article.audio || (article.hasAudio() && !selectedArticle.video);
			},
			mp3: function () {
				let article = this.article;
				let selectedArticle = this.selectedArticle;
				let hasAudio = this.hasAudio;

				if (!article) {
					return null;
				}
				if (selectedArticle && selectedArticle.audio) {
					article = this.selectedArticle;
				}

				if (hasAudio) {
					var endpoint = (config.resources.media.cdn || config.resources.media.origin) + '/data/audio/';
					return endpoint + article.audio + '.mp3';
				}
				return null;
			},
			showKor1ListeningLevelButterBar() {
				if (
					this.hideKor1ListeningLevelButterBar ||
					this.userIsUnauthenticated ||
					this.student ||
					this.routeContext.route !== 'article' ||
					this.decodables ||
					this.article.dteGroups
				) {
					return false;
				}

				const grades = this.article.grades || [];
				const kOr1 = new Set([16, 17]);

				return grades.some(grade => kOr1.has(grade));
			}
		},
		methods: {
			forceLogin: function () {
				utilities.openModal('#teacher-login-modal');
			},
			audioAuthenticationCheck: function (event) {
				if (this.userIsUnauthenticated) {
					if (event) {
						event.player.pause();
					}
					this.forceLogin();
				}
			},
			hideListeningLevelButterBar() {
				this.hideKor1ListeningLevelButterBar = true;
				fireEvent(LISTENING_LEVEL_BUTTER_BAR_HIDDEN);
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/variables';
	@import 'config/colors';

	.article-body {
		> .content-column article {
			padding-right: $size-medium;
		}

		.listening-level-butter-bar {
			margin: 1rem 0.5rem 0 0;

			p:first-of-type {
				margin-top: 0;
			}
		}

		.listening-level-butter-bar-hide:not(:hover) {
			color: $c-blue-dark;
		}
	}
</style>
<template>
	<div
		class="article-body row"
		:class="{
			'paywall-absolute-position': paywallAbsolutePositioning,
			unauthenticated: userIsUnauthenticated
		}">
		<div
			class="content-column columns"
			:class="{
				'large-8': !student
			}"
			aria-live="polite">
			<butter-bar-promo
				v-if="showKor1ListeningLevelButterBar"
				class="listening-level-butter-bar"
				dismiss-key="dismissKor1ListeningLevelButterBar"
				:event-data="{ name: 'K_OR_1_LISTENING_LEVEL' }">
				<p>
					ReadWorks kindergarten and 1st grade passages are written at students' listening-level comprehension. Try our
					<outbound-link
						href="https://about.readworks.org/uploads/7/9/6/7/79679564/readworks_read-aloud_protocol_for_k-1_readers.pdf"
						data-outbound-link="ARTICLE_K_OR_1_LISTENING_LEVEL"
						>read-aloud protocol</outbound-link
					>
					to deepen students' language comprehension, background knowledge, and vocabulary.
				</p>
				<div class="text-centered">
					<button
						class="button -link listening-level-butter-bar-hide"
						type="button"
						@click="hideListeningLevelButterBar">
						Don't show again
					</button>
				</div>
			</butter-bar-promo>
			<article-selection
				v-if="articleList && articleList.length > 0"
				:article="article"
				:selected-article="selectedArticle"
				:article-list="articleList"
				:show-challenge="showChallenge"
				:show-support="showSupport"
				:step-read="stepRead"
				:decodables="decodables"
				:annotations="annotations"
				@article-selected="onArticleSelect"></article-selection>
			<h1
				v-if="article && !['AAD', 'TS'].includes(article.productType) && selectedArticle"
				class="print-only print-centered">
				{{ selectedArticle.title }}
			</h1>
			<template v-if="article && ['AAD', 'TS'].includes(article.productType) && selectedArticle">
				<h1
					class="rte print-centered"
					style="margin: 0">
					<strong>{{ selectedArticle.title }}</strong>
				</h1>
				<div
					v-if="selectedArticle"
					class="font-small font-light margin-bottom-medium">
					<template v-if="selectedArticle.authors.length"> By {{ selectedArticle.authors | join }} ({{ selectedArticle.wordCount }} words) </template>
					<template v-else> {{ selectedArticle.wordCount }} words </template>
				</div>
			</template>
			<paywall-print-warning v-if="userIsUnauthenticated"> </paywall-print-warning>
			<audio-player
				v-if="hasAudio && showAudio && article && selectedArticle"
				:src="mp3"
				:event-data="{
					parentPid: selectedArticle && article ? article.uuid : undefined,
					pid: selectedArticle.uuid,
					tag: 'article',
					aid: routeContext.params.assignmentId ? routeContext.params.assignmentId : undefined
				}"
				:show-speed-selector="true"
				@play="audioAuthenticationCheck">
			</audio-player>
			<article>
				<div
					class="article-single-main-acknowledgment rte"
					v-if="selectedArticle && selectedArticle.acknowledgment">
					<p>
						{{ selectedArticle.acknowledgment }}
					</p>
				</div>
				<product-news-header
					v-if="isNewsArticle && selectedArticle"
					:banner="selectedArticle.banner"
					:title="selectedArticle.title"
					:sub-headline="selectedArticle.subHeadline"
					:byline="selectedArticle.byline"
					:news-date="selectedArticle.newsDate">
				</product-news-header>
				<video-content
					v-if="isVideoArticle && selectedArticle"
					:video="selectedArticle.video"
					:auth="true">
				</video-content>
				<vocab-popup-content-wrapper
					is-teacher
					:event-data="{
						parentPid: selectedArticle && selectedArticle.uuid !== article.uuid ? article.uuid : null,
						assignmentId: routeContext.params.assignmentId || null,
						loc: routeContext.route
					}"
					:article="selectedArticle || article">
					<annotated-text
						v-if="!isVideoArticle && (student || forceHighlighting)"
						:content="(selectedArticle && selectedArticle.content) || (article && article.content)"
						:assignment-id="hasWorkspace && routeContext.params.assignmentId"
						:uuid="(selectedArticle && selectedArticle.uuid) || (article && article.uuid)"
						:student-uid="student"
						:allow-edit="forceHighlighting"
						:persist="!forceHighlighting"
						:minimal="forceHighlighting && article.productType === 'AAD'"
						:paragraphs-numbered="paragraphsNumbered"
						:language="selectedArticle && selectedArticle.language">
					</annotated-text>
					<div
						v-if="!forceHighlighting && !isVideoArticle && !student"
						v-html="content"></div>
				</vocab-popup-content-wrapper>
				<paywall v-if="userIsUnauthenticated"></paywall>
			</article>
			<div
				class="article-single-main-footer"
				v-if="selectedArticle && selectedArticle.copyright">
				<p v-html="selectedArticle.copyright"></p>
			</div>
		</div>
		<div
			v-if="!student && article && selectedArticle"
			class="large-4 columns print-hidden">
			<article-aside
				:article="selectedArticle"
				:product="article"
				:description="article.description"
				:pair-text="article.productType === 'P'"
				:stepread="stepRead"
				:decodables="decodables"
				:search-query-string="routeContext.parsedPath.getQueryParam('search')"></article-aside>
		</div>
	</div>
</template>
